"use client";

import {GoogleTagManager, sendGTMEvent} from "@next/third-parties/google";
import React, {useEffect} from "react";
import FBPixel from "../FBPixel/FBPixel";
//import {usePathname} from "next/navigation";

export default function TrackingScripts() {

    //const pathname = usePathname();

/*    useEffect(() => {
        sendGTMEvent({
            event: 'gtm.js',
            page_title: document.title,
            page_path: window.location.pathname,
            page_location: window.location.href,
        });
       // console.log("Firing the page view", new Date(), window.location.pathname);
    }, [pathname]);*/

    return (
        <>
            <GoogleTagManager gtmId="GTM-T37V852" dataLayer={[
                ['set', 'url_passthrough', true],
            ]}/>
            <FBPixel/>
        </>

    );
}